interface explainerVideoPickerProps {
  isTrackerless: boolean
  isRefundAtRenewal: boolean
  fixed: string
  pmRate: string
  estimatedMilage: string
  yearlyEstimate: string
  carMake: string
}

export const explainerVideoPicker = ({
  isTrackerless,
  isRefundAtRenewal,
  fixed,
  pmRate,
  estimatedMilage,
  yearlyEstimate,
  carMake,
}: explainerVideoPickerProps) => {
  let url: string
  if (!isRefundAtRenewal) {
    url = `../v2/assets/explainer-video/index.html?fixed=${fixed}&pmRate=${pmRate}&estimatedMileage=${estimatedMilage}&yearlyEstimate=${yearlyEstimate}&carMake=${carMake}&connected=${isTrackerless}`
  } else if (isTrackerless) {
    url = 'https://www.youtube.com/embed/NBl8i5qmIMY?si=6ns61u-N66AFw392&autoplay=1&mute=1&cc_load_policy=1&rel=0'
  } else {
    url = 'https://www.youtube.com/embed/6fzAL4vnn3w?si=RLMLjib52Zj08-NY&autoplay=1&mute=1&cc_load_policy=1&rel=0'
  }
  return url
}
